module.exports = __webpack_public_path__ + "img/hkoig2.79d53141.png";